/* ClearSight: PRO-parity behaviors (splide sliders, scroll reveal, cart countdown) */
(function(){
  // scroll reveal (Shrine PRO animate-section)
  function reveal(){
    var secs=document.querySelectorAll('.animate-section.animate--hidden');
    if(!('IntersectionObserver' in window)){secs.forEach(function(e){e.classList.replace('animate--hidden','animate--shown')});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.remove('animate--hidden');e.target.classList.add('animate--shown');io.unobserve(e.target);}})},{threshold:0.1});
    secs.forEach(function(e){io.observe(e)});
  }
  document.readyState!=='loading'?reveal():document.addEventListener('DOMContentLoaded',reveal);
})();
if(!customElements.get('splide-component')){
customElements.define('splide-component',class extends HTMLElement{
  connectedCallback(){var self=this;var go=function(){if(window.Splide)self.init();else setTimeout(go,100)};go();}
  init(){
    var d=this.dataset, el=this.querySelector('.splide'); if(!el||this._s) return;
    var isDesk=window.matchMedia('(min-width: 750px)').matches;
    if(d.destroyDesktop==='true'&&isDesk){el.classList.add('is-initialized','splide--destroyed');return;}
    var o={type:d.type||'slide',autoplay:d.autoplay==='true',interval:(+d.autoplaySpeed||5)*1000,perPage:+d.slidesDesktop||1,perMove:+d.perMoveDesktop||1,gap:(+d.gapDesktop||0)+'px',
      padding:{left:(+d.sidePaddingDesktop||0)+'px',right:(+d.sidePaddingDesktop||0)+'px'},omitEnd:d.omitEnd==='true',pauseOnHover:true,
      breakpoints:{749:{perPage:+d.slidesMobile||1,perMove:+d.perMoveMobile||1,gap:(+d.gapMobile||0)+'px',padding:{left:(+d.sidePaddingMobile||0)+'px',right:(+d.sidePaddingMobile||0)+'px'}}}};
    if(el.classList.contains('splide--desktop-arrows-hidden')&&el.classList.contains('splide--mobile-arrows-hidden')) o.arrows=false;
    if(el.classList.contains('splide--desktop-dots-hidden')&&el.classList.contains('splide--mobile-dots-hidden')) o.pagination=false;
    this._s=new Splide(el,o).mount();
  }
});}
if(!customElements.get('countdown-timer')){
customElements.define('countdown-timer',class extends HTMLElement{
  connectedCallback(){var t=+this.dataset.duration||600,self=this;var f=function(){var m=Math.floor(t/60),s=t%60;self.textContent=(m<10?'0':'')+m+':'+(s<10?'0':'')+s;if(t>0){t--;setTimeout(f,1000);}};f();}
});}
